/* eslint-disable */
import Sidebar from "../components/Sidebar";
import MobileHeader from "../components/MobileHeader";
import OrdersTable from "../components/OrdersTable";
import ProtectDashboardRoute from "../components/ProtectDashboardRoute";

export default function SmsOrdersPage() {
  return (
    <div className="flex min-h-screen bg-gray-50">
      <ProtectDashboardRoute />
      {/* Sidebar */}
      <Sidebar />
      <MobileHeader />

      {/* Main Content */}
      <div className="flex-1 flex flex-col p-2">
        {/* Header Section */}

        <OrdersTable />
      </div>
    </div>
  );
}
